import ComponentAnimation from "./ComponentAnimation";

export default function ProjectBox({ children }) {
  return (
    <ComponentAnimation className="project-box">{children}</ComponentAnimation>
  );
}
